import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createUnknownComponentVNode as _$cc, createVNode as _$cv, className as _$cn } from 'intact-vue-next';
import { Transition } from 'intact-vue-next';
import { getRestProps } from '../utils';
import { makeItemStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    children = _this$get.children,
    value = _this$get.value,
    cloned = _this$get.cloned;
  var parent = this.$senior;
  var active = parent.isActive(value);
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-carousel-item"] = true, _classNameObj[className] = className, _classNameObj[k + "-active"] = active, _classNameObj[k + "-cloned"] = cloned, _classNameObj[makeItemStyles(k)] = true, _classNameObj);
  var isSlide = parent.get('effect') === 'slide';
  return _$cc(Transition, {
    'show': active || isSlide,
    'name': 'k-carousel-fade',
    'children': _$cv('div', _extends({
      'className': _$cn(classNameObj)
    }, getRestProps(this)), children)
  });
}
;